import React from 'react';
import '../styles/LoadingSpinner.css';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className = '' }) => (
    <div
        className={`loading-spinner loading-spinner-${size} ${className}`}
        role="status"
        aria-label="載入中"
    >
        <div className="loading-spinner-ring" />
    </div>
);

export default LoadingSpinner;
